exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.fb-signin-button[data-v-4639697c] {\n  display: inline-block;\n  background-color: #4267b2;\n  color: #fff;\n}\n.fb-icon[data-v-4639697c] {\n  background-image: url(" + require(".././assets/button_fb_logo.svg") + ");\n  background-repeat: no-repeat;\n  height: 16px;\n  width: 16px;\n  display: inline-block;\n  margin-right: 1rem;\n  margin-bottom: -2px;\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4639697c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LoginView.vue
// module id = LKWI
// module chunks = 14